/* eslint-disable max-lines */

import { inject, observer } from 'mobx-react';
import { ExperimentStore } from 'bernie-plugin-mobx';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { updateSearch } from 'bernie-core';

import { IClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { LocalizedComponentProps } from '@shared-ui/localization-context';
import { PropertySearchMapTrigger } from '@shared-ui/lodging-property-search';
import { SortAndFiltersViewType } from '@shared-ui/retail-sort-and-filter-lodging';

import { changeView, View, ViewTracker } from 'src/common/stores/contexts/viewTracker';
import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { PROPERTY_LISTING_BATCH_KEY } from 'constants/batchKeys';

import { UitkEGMapsQualifier } from 'uitk-react-map';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { DynamicSearchMapWrapper } from './dynamic-search-map-wrapper';
import { EGMapConfiguration } from '@eg-maps/core';
import { LodgingPwaPropertySearchQueryVariables } from '__generated__/api';
import { parse } from 'query-string';
import { UniversalSortFilterWrapper } from '../sort-filter/universal-sort-filter';

const egMapConfiguration: EGMapConfiguration = {
  markers: {
    place: {
      zIndex: {
        unknown: 0,
      },
    },
    property: {
      zIndex: {
        [`${UitkEGMapsQualifier.NOT_CLUSTERED}`]: 0,
      },
    },
  },
};

export interface MapPreviewProps extends LocalizedComponentProps, Partial<RouteComponentProps> {
  multiItem?: MultiItemStore;
  tracker: IClickstreamAnalytics;
  viewTracker: ViewTracker;
  mapSortAndFilterViewType?: SortAndFiltersViewType;
  dialogView?: SortAndFiltersViewType;
  experiment?: ExperimentStore;
  searchInputs?: LodgingPwaPropertySearchQueryVariables;
  searchResults?: SearchResultsStore;
}

// @ts-ignore
@withRouter
@inject('multiItem', 'experiment', 'searchResults')
@observer
export class MapPreview extends React.Component<MapPreviewProps> {
  private mapBtn: any;

  constructor(props: MapPreviewProps) {
    super(props);

    this.onMapDialogClosed = this.onMapDialogClosed.bind(this);
    this.mapBtn = React.createRef();
  }

  public render() {
    const {
      location,
      dialogView,
      mapSortAndFilterViewType = SortAndFiltersViewType.FILTER_DIALOG,
      experiment,
      searchInputs,
      searchResults,
    } = this.props;

    if (!searchResults?.mapTrigger) {
      return null;
    }
    const locationSearch = location?.search ? (parse(location.search) as Record<string, string>) : undefined;

    const inputs = searchInputs ?? {
      destination: { regionName: locationSearch?.destination, pinnedPropertyId: locationSearch?.selected },
    };

    const batchKey = experiment?.exposures?.SHOPPING_PWA_BATCHING_SRP_QUERY?.bucket === 1 ? PROPERTY_LISTING_BATCH_KEY : undefined;

    const triggerRef = (mapBtn: any) => {
      this.mapBtn = mapBtn;
    };

    const dynamicSearchMapWrapper = (
      <DynamicSearchMapWrapper
        cfg={egMapConfiguration}
        clientPadding="32px"
        onMapDialogClosed={this.onMapDialogClosed}
        filterComponent={
          <UitkLayoutFlexItem shrink={0}>
            <UniversalSortFilterWrapper view={mapSortAndFilterViewType} />
          </UitkLayoutFlexItem>
        }
        triggerRef={triggerRef}
      />
    );

    return (
      <PropertySearchMapTrigger inputs={inputs} dialogView={dialogView} batchKey={batchKey} externalData={searchResults?.mapTrigger}>
        {dynamicSearchMapWrapper}
      </PropertySearchMapTrigger>
    );
  }

  private onMapDialogClosed(): void {
    const { history, location, multiItem, tracker, viewTracker } = this.props;
    history &&
      location &&
      updateSearch({
        history,
        location,
        newParams: {
          pwaOverlay: '',
        },
      });

    changeView(tracker, viewTracker, View.LISTINGS, multiItem?.getPackageType() ?? undefined);

    if (this.mapBtn && typeof this.mapBtn.focus === 'function') {
      this.mapBtn.focus();
    }
  }
}
